import React from 'react';
import { Alert, Button, Input, Modal } from 'antd';
import styles from '@pages/api-portal/styles.module.scss';
import { CreateServicePrincipalRequest } from '@pages/api-portal/types';

interface CreateServicePrincipalDialogProps {
    open: boolean;
    onClose: () => void;
    form: CreateServicePrincipalRequest;
    onFormChange: (form: CreateServicePrincipalRequest) => void;
    isCreating: boolean;
    error: string | null;
    onSubmit: () => void;
}

/*
 * Dialog for creating a new service principal — name/description only, status defaults
 * to "active" server-side.
 */
export function CreateServicePrincipalDialog({
    open,
    onClose,
    form,
    onFormChange,
    isCreating,
    error,
    onSubmit,
}: CreateServicePrincipalDialogProps) {
    return (
        <Modal
            title={
                <div>
                    <div>Create Service Principal</div>
                    <div className={styles.fieldHint} style={{ fontWeight: 400 }}>
                        Create a new service principal for programmatic API access.
                    </div>
                </div>
            }
            visible={open}
            onCancel={onClose}
            wrapClassName="apimModal"
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={isCreating} disabled={!form.name.trim()} onClick={onSubmit}>
                    Create
                </Button>,
            ]}
        >
            {error && <Alert style={{ marginBottom: 16 }} type="error" message={error} showIcon />}
            <div style={{ marginBottom: 16 }}>
                <label className={styles.fieldLabel}>
                    Name <span className={styles.requiredMark}>*</span>
                </label>
                <Input
                    placeholder="e.g., production-pipeline-runner"
                    value={form.name}
                    onChange={(e) => onFormChange({ ...form, name: e.target.value })}
                />
                <p className={styles.fieldHint}>No spaces allowed. Use hyphens (-) or underscores (_).</p>
                <p className={styles.fieldHint} style={{ marginTop: 0 }}>
                    Email will be: {form.name || '{name}'}@deepiq.com
                </p>
            </div>
            <div>
                <label className={styles.fieldLabel}>Description</label>
                <Input.TextArea
                    placeholder="What will this service principal be used for?"
                    value={form.description}
                    onChange={(e) => onFormChange({ ...form, description: e.target.value })}
                    rows={2}
                />
            </div>
        </Modal>
    );
}
